import { appendParams } from '@constants'
import { THEME_NAME } from '@root/styles'
import { normalizeReferralCode, parseReferralCode, REFERRAL_QUERY_PARAM } from './parseReferral'

const REFERRAL_SIGNUP_PATH = '/auth/signup/'

export const buildReferralSignupLink = (code: string): string => {
  const signupUrl = `${import.meta.env.VITE_AUTH_BASE_URL}${REFERRAL_SIGNUP_PATH}`
  const normalizedCode = normalizeReferralCode(code)
  if (!normalizedCode) {
    return signupUrl
  }

  return appendParams(signupUrl, {
    [REFERRAL_QUERY_PARAM]: normalizedCode,
    theme: THEME_NAME
  })
}

export const resolveReferralShareLink = (payload: { code: string; link: string }): string => {
  const code = normalizeReferralCode(payload.code) ?? parseReferralCode(payload.link)
  return code ? buildReferralSignupLink(code) : payload.link
}
